module.exports = __webpack_public_path__ + "img/1_025.9e27801f.jpg";